import { render, staticRenderFns } from "./OtherLoanListingCount.vue?vue&type=template&id=f4ca91c4"
import script from "./OtherLoanListingCount.vue?vue&type=script&lang=js"
export * from "./OtherLoanListingCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports